export const PAGINATION = {
  page_number: 10,
  first_page: 1,
  delay_time: 1000
};
